export default {
  root: {
    class: ['flex', 'flex-col'],
  },
}
